<div class="p-grid" *ngIf="!loading">
  <div>
    <span class="counter-title">Offer</span>
  </div>
  <div [@balloonEffect]=currentState>
    <span class="counter new" (click)="navigateToOffer()" title="New">
      {{counters?.New}}
    </span>
  </div>
  <div [@balloonEffect]=currentState>
    <span class="counter negotiate" (click)="navigateToOffer()" title="Negotiating">
      {{counters?.Negotiate}}
    </span>
  </div>
  <div [@balloonEffect]=currentState>
    <span class="counter rejected" (click)="navigateToOffer()" title="Rejected">
      {{counters?.Rejected}}
    </span>
  </div>
  <div [@balloonEffect]=currentState>
    <span class="counter held" (click)="navigateToOffer()" title="Held">
      {{counters?.Held}}
    </span>
  </div>
  <div [@balloonEffect]=currentState>
    <span class="counter accepted" (click)="navigateToOffer()" title="Accepted">
      {{counters?.Accepted}}
    </span>
  </div>
</div>
